module.exports = __webpack_public_path__ + "img/profileSigned.94b83edb.svg";